import { ActionType } from "./types";
import * as actionTypes from "../action";

const initialState: any = {
  loading: false,
};

const applicationReducer = (state = initialState, action: ActionType) => {
  switch (action.type) {
    case actionTypes.REQUEST_STARTED: {
      return {
        ...state,
        loading: true,
      };
    }
    case actionTypes.REQUEST_COMPLETED: {
      return {
        ...state,
        loading: false,
      };
    }
    default: {
      return state;
    }
  }
};

export default applicationReducer;
